import React, { useState } from "react";
import { IconCircleCheckFilled } from "@tabler/icons-react";
import { Button, FieldError, Input, Textarea } from "../utils/ui";

export default function ClienteForm({ onSubmit, onCancel, saving = false, serverError = null }) {
  const [name, setName] = useState("");
  const [rfc, setRfc] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [contactName, setContactName] = useState("");
  const [address, setAddress] = useState("");
  const [notes, setNotes] = useState("");
  const [error, setError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    if (!name.trim()) return setError("El nombre es obligatorio.");
    onSubmit({
      name: name.trim(),
      rfc: rfc || null,
      email: email || null,
      phone: phone || null,
      contact_name: contactName || null,
      address: address || null,
      status: "active",
      notes: notes || null,
    });
  };

  return (
    <form onSubmit={submit} className="space-y-4">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <Input label="Nombre o razón social *" value={name} onChange={(e) => setName(e.target.value)} placeholder="Ej. Taquería El Norte" />
        <Input label="RFC" value={rfc} onChange={(e) => setRfc(e.target.value)} placeholder="Ej. TEN991231AB1" />
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <Input label="Teléfono" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Ej. 664-123-4567" />
        <Input label="Correo" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Ej. contacto@empresa.mx" />
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
        <Input label="Persona de contacto" value={contactName} onChange={(e) => setContactName(e.target.value)} placeholder="Nombre del responsable" />
        <Input label="Dirección" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Calle, número, ciudad" />
      </div>

      <Textarea label="Notas" value={notes} onChange={(e) => setNotes(e.target.value)} rows={2} placeholder="Notas internas (opcional)" />

      <FieldError message={serverError || error} />

      <div className="flex justify-end gap-3 border-t border-white/10 pt-4">
        <Button type="button" variant="secondary" onClick={onCancel} disabled={saving}>
          Cancelar
        </Button>
        <Button type="submit" disabled={saving}>
          <IconCircleCheckFilled className="h-4 w-4 text-white" />
          {saving ? "Guardando..." : "Crear cliente"}
        </Button>
      </div>
    </form>
  );
}